import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetStudioProductStatuses = (): Promise<any> =>
    request({
        url: ApiURL.Query.StudioQueryURLs.StudioProductStatusQueryURL.GetStudioProductStatuses,
        method: RequestType.GET,
    });

export const StudioProductStatusQuery = {
    GetStudioProductStatuses,
};

export default StudioProductStatusQuery;
